import getPaymentMethodsQuery from '@paywall/graphql/getPaymentMethods.graphql';
import convertToNamedPaymentMethods from '@paywall/utils/convertToNamedPaymentMethods';
import errorLogger from '@paywall/utils/errorLogger';
import { GetPaymentMethods } from '@paywall/types/getPaymentMethods';

import ServiceBase from '@ekd/portal-connector/dist/Service';
import { ApiUrls } from '@root/common/types/apiUrls';
import { RootInstance } from '@root/plugins/instance-connector/RootInstance';

/**
 *
 * Get article payment methods ('selfService' | 'zlick')
 * @returns data that's needed for zlick payment (price, token etc)
 */
export function createGetPaymentMethodsService({ service, instances }: { service: ServiceBase<ApiUrls>; instances?: { root?: RootInstance } }) {
  return {
    async getPaymentMethods(channelId: string, articleId: string) {
      const variables = { channelId: Number(channelId), articleId };

      try {
        const apiProvider = service.createProvider('GraphQL');
        apiProvider.selectAPI('paywall-api');

        const data = await apiProvider.request<GetPaymentMethods['data']>({ query: getPaymentMethodsQuery, variables });
        return { ...data, methods: convertToNamedPaymentMethods(data.methods) };
      } catch (error) {
        errorLogger({ name: 'getPaymentMethods()', message: error });
        instances?.root && instances.root.alert({ type: 'error', title: 'error.unexpected_system_error' });
        return null;
      }
    },
  };
}
